import { useMutation } from '@apollo/client';

import { UpdateDeliveryAddressStreetAdditionDocument } from './updateStreetAddition.gql';

export function useUpdateStreetAddition() {
  return useMutation(UpdateDeliveryAddressStreetAdditionDocument);
}
